/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateOrUpdateMedicalSystemSetupBaseDto } from './CreateOrUpdateMedicalSystemSetupBaseDto';
import {
    CreateOrUpdateMedicalSystemSetupBaseDtoFromJSON,
    CreateOrUpdateMedicalSystemSetupBaseDtoFromJSONTyped,
    CreateOrUpdateMedicalSystemSetupBaseDtoToJSON,
} from './CreateOrUpdateMedicalSystemSetupBaseDto';
import type { CreateTaskItemQaEquipmentSetupDto } from './CreateTaskItemQaEquipmentSetupDto';
import {
    CreateTaskItemQaEquipmentSetupDtoFromJSON,
    CreateTaskItemQaEquipmentSetupDtoFromJSONTyped,
    CreateTaskItemQaEquipmentSetupDtoToJSON,
} from './CreateTaskItemQaEquipmentSetupDto';
import type { GetCombinationTableDtoPreviousTable } from './GetCombinationTableDtoPreviousTable';
import {
    GetCombinationTableDtoPreviousTableFromJSON,
    GetCombinationTableDtoPreviousTableFromJSONTyped,
    GetCombinationTableDtoPreviousTableToJSON,
} from './GetCombinationTableDtoPreviousTable';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface GetCombinationTableDto
 */
export interface GetCombinationTableDto {
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof GetCombinationTableDto
     */
    taskType?: TaskTypeDescription;
    /**
     * 
     * @type {CreateOrUpdateMedicalSystemSetupBaseDto}
     * @memberof GetCombinationTableDto
     */
    medicalSystemSetup?: CreateOrUpdateMedicalSystemSetupBaseDto;
    /**
     * 
     * @type {Array<CreateTaskItemQaEquipmentSetupDto>}
     * @memberof GetCombinationTableDto
     */
    qaEquipmentSetups?: Array<CreateTaskItemQaEquipmentSetupDto> | null;
    /**
     * 
     * @type {GetCombinationTableDtoPreviousTable}
     * @memberof GetCombinationTableDto
     */
    previousTable?: GetCombinationTableDtoPreviousTable | null;
    /**
     * 
     * @type {string}
     * @memberof GetCombinationTableDto
     */
    $type?: GetCombinationTableDtoTypeEnum;
}


/**
 * @export
 */
export const GetCombinationTableDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedTaskItemComponentDtoGetCombinationTableDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.TaskItemComponent.Dto.GetCombinationTableDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type GetCombinationTableDtoTypeEnum = typeof GetCombinationTableDtoTypeEnum[keyof typeof GetCombinationTableDtoTypeEnum];


/**
 * Check if a given object implements the GetCombinationTableDto interface.
 */
export function instanceOfGetCombinationTableDto(value?: unknown): value is GetCombinationTableDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(GetCombinationTableDtoTypeEnum)[0];
}

export function GetCombinationTableDtoFromJSON(json: any): GetCombinationTableDto {
    return GetCombinationTableDtoFromJSONTyped(json, false);
}

export function GetCombinationTableDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCombinationTableDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskType': !exists(json, 'taskType') ? undefined : TaskTypeDescriptionFromJSON(json['taskType']),
        'medicalSystemSetup': !exists(json, 'medicalSystemSetup') ? undefined : CreateOrUpdateMedicalSystemSetupBaseDtoFromJSON(json['medicalSystemSetup']),
        'qaEquipmentSetups': !exists(json, 'qaEquipmentSetups') ? undefined : (json['qaEquipmentSetups'] === null ? null : (json['qaEquipmentSetups'] as Array<any>).map(CreateTaskItemQaEquipmentSetupDtoFromJSON)),
        'previousTable': !exists(json, 'previousTable') ? undefined : GetCombinationTableDtoPreviousTableFromJSON(json['previousTable']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function GetCombinationTableDtoToJSON(value?: GetCombinationTableDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'medicalSystemSetup': CreateOrUpdateMedicalSystemSetupBaseDtoToJSON(value.medicalSystemSetup),
        'qaEquipmentSetups': value.qaEquipmentSetups === undefined ? undefined : (value.qaEquipmentSetups === null ? null : (value.qaEquipmentSetups as Array<any>).map(CreateTaskItemQaEquipmentSetupDtoToJSON)),
        'previousTable': GetCombinationTableDtoPreviousTableToJSON(value.previousTable),
        '$type': value.$type,
    });
}

